import React from 'react'
import { Box, useTheme } from '@mui/material'
import LightModeIcon from '../../assets/siderbar_icons/LightMode.svg'
import DarkModeIcon from '../../assets/siderbar_icons/DarkMode.svg'

interface ThemeToggleProps {
  isDarkMode: boolean
  onThemeToggle: () => void
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({
  isDarkMode,
  onThemeToggle,
}) => {
  const theme = useTheme()
  
  return (
    <Box
      sx={{
        display: 'flex',
        // backgroundColor: theme.palette.mode === 'dark' 
        //   ? theme.palette.background.paper 
        //   : theme.palette.grey[100],
        borderRadius: '8px',
        width: 'fit-content',
        padding: '3px',
        border: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Box
        sx={{
          paddingTop: '7px',
          paddingLeft: '5px',
          paddingRight: '5px',
          backgroundColor: !isDarkMode 
            ? theme.palette.primary.main 
            : 'transparent',
          color: !isDarkMode 
            ? theme.palette.primary.contrastText 
            : theme.palette.text.primary,
          borderRadius: '6px',
          transition: 'all 0.2s ease',
          cursor: !isDarkMode ? 'default' : 'pointer',
          '&:hover': {
            backgroundColor: !isDarkMode 
              ? theme.palette.primary.main 
              : theme.palette.action.hover,
          },
        }}
        onClick={!isDarkMode ? undefined : onThemeToggle}
      >
        <img 
          src={LightModeIcon} 
          alt="Light Mode" 
          style={{ 
            width: 20,
            filter: 'brightness(0) invert(1)'
          }} 
        />
      </Box>
      <Box
        sx={{
          paddingTop: '7px',
          paddingLeft: '5px',
          paddingRight: '5px',          marginLeft: '5px',
          backgroundColor: isDarkMode 
            ? theme.palette.primary.main 
            : 'transparent',
          color: isDarkMode 
            ? theme.palette.primary.contrastText 
            : theme.palette.text.primary,
          borderRadius: '6px',
          transition: 'all 0.2s ease',
          cursor: isDarkMode ? 'default' : 'pointer',
          '&:hover': {
            backgroundColor: isDarkMode 
              ? theme.palette.primary.main 
              : theme.palette.action.hover,
          },
        }}
        onClick={isDarkMode ? undefined : onThemeToggle}
      >
        <img 
          src={DarkModeIcon} 
          alt="Dark Mode" 
          style={{ 
            width: 20,
            filter: isDarkMode ? 'brightness(0) invert(1)' : 'none'
          }} 
        />
      </Box>
    </Box>
  )
}

export default ThemeToggle
